import { reactive } from "vue";
import * as io from 'socket.io-client'

export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: []
});

const URL = process.env.MIX_VUE_APP_AUDITORIO_LANCE;

export const socket_lances = io(URL);

socket_lances.on("connect", () => {
  state.connected = true;
});

socket_lances.on("disconnect", () => {
  state.connected = false;
});

socket_lances.on("bar", (...args) => {
  state.barEvents.push(args);
});